// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onedrive-page-container {
   position: relative;
}

.browse-folder {
   display: inline-block;
   margin-right: 5px;
   width: 24px;
   vertical-align: text-bottom;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.title {
   font-size: 18px;
   line-height: 30px;
   overflow: hidden;
   white-space: nowrap;
}

.fixed-toolbar {
   align-items: center;
   background-color: #fff;
   border-bottom: 1px solid #eaeaea;
   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
   position: fixed;
   left: 240px;
   top: 50px;
   height: 50px;
   right: 0;
   padding: 0 20px;
   z-index: 5;
}

.fixed-toolbar ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.toolbar {
   align-items: center;
}

.menu>li {
   float: left;
}

.menu>li+li {
   margin-left: 1em;
}

.menu>li>a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu>li>a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open>a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu i {
   font-size: 16px;
}

.menu em {
   font-size: 16px;
}

.menu mat-icon {
   font-size: 20px;
   width: 20px;
   height: 20px;
}

.menu i+span, .menu mat-icon+span {
   margin-left: 10px;
}

.menu span+i {
   margin-left: 10px;
}

.menu em+span, .menu mat-icon+span {
   margin-left: 10px;
}

.menu span+em {
   margin-left: 10px;
}

.menu button {
   min-width: 0;
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.div-header-chk-all {
   display: inherit;
}

.drag-over {
   background-color: rgba(0, 188, 212, .2);
   opacity: .5;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/onedrive-page/onedrive-page.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;GACX,2BAA2B;AAC9B;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,mBAAmB;GACnB,sBAAsB;GACtB,gCAAgC;GAChC,6CAA6C;GAC7C,eAAe;GACf,WAAW;GACX,SAAS;GACT,YAAY;GACZ,QAAQ;GACR,eAAe;GACf,UAAU;AACb;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,WAAW;GACX,YAAY;AACf;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,uCAAuC;GACvC,WAAW;AACd","sourcesContent":[".onedrive-page-container {\n   position: relative;\n}\n\n.browse-folder {\n   display: inline-block;\n   margin-right: 5px;\n   width: 24px;\n   vertical-align: text-bottom;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.title {\n   font-size: 18px;\n   line-height: 30px;\n   overflow: hidden;\n   white-space: nowrap;\n}\n\n.fixed-toolbar {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n   position: fixed;\n   left: 240px;\n   top: 50px;\n   height: 50px;\n   right: 0;\n   padding: 0 20px;\n   z-index: 5;\n}\n\n.fixed-toolbar ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu>li {\n   float: left;\n}\n\n.menu>li+li {\n   margin-left: 1em;\n}\n\n.menu>li>a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu>li>a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open>a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu i {\n   font-size: 16px;\n}\n\n.menu em {\n   font-size: 16px;\n}\n\n.menu mat-icon {\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n}\n\n.menu i+span, .menu mat-icon+span {\n   margin-left: 10px;\n}\n\n.menu span+i {\n   margin-left: 10px;\n}\n\n.menu em+span, .menu mat-icon+span {\n   margin-left: 10px;\n}\n\n.menu span+em {\n   margin-left: 10px;\n}\n\n.menu button {\n   min-width: 0;\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.div-header-chk-all {\n   display: inherit;\n}\n\n.drag-over {\n   background-color: rgba(0, 188, 212, .2);\n   opacity: .5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
